import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import React, { useMemo } from 'react'
import useContentTag from 'hooks/Content/useContentTag'
import { getContentTagIcon } from './contentTagIconUtils'

interface Props {
  slug: string
}

/**
 * Renders a single ContentTag as a PromotionLabel.
 */
function ContentTagLabel({ slug }: Props) {
  const { contentTag } = useContentTag(slug)

  const icon = useMemo(() => {
    if (!contentTag) {
      return undefined
    }
    return getContentTagIcon(contentTag.fields.icon)
  }, [contentTag])

  if (!contentTag) {
    return null
  }

  return (
    <PromotionLabel variant="engagement" icon={icon}>
      {contentTag.fields.title}
    </PromotionLabel>
  )
}

export default ContentTagLabel
